import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/windDirection.svg'


const _hoisted_1 = { class: "wp1200 withPadding" }
const _hoisted_2 = { class: "flex justify-content-between border-bottom-1 border-gray-400 align-items-center" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_bell_full text-white border-1 border-circle border-dashed border-white p-1 inline-block" }, null, -1)
const _hoisted_5 = { class: "singleCity" }
const _hoisted_6 = { class: "city" }
const _hoisted_7 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_8 = { class: "detailInfo" }
const _hoisted_9 = { class: "flex icon" }
const _hoisted_10 = {
  ref: "canvas",
  height: "300"
}
const _hoisted_11 = {
  key: 0,
  class: "temperature"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "celsius" }, "°C", -1)
const _hoisted_13 = {
  key: 0,
  class: "data"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_rel-vlaznost" }, null, -1)
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_zracni-tlak" }, null, -1)
const _hoisted_17 = { class: "mbar" }
const _hoisted_18 = { class: "flex top" }
const _hoisted_19 = { class: "flex responsive" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_wind" }, null, -1)
const _hoisted_21 = ["alt"]
const _hoisted_22 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_23 = { class: "flex" }
const _hoisted_24 = { class: "dayAndDate" }
const _hoisted_25 = { class: "day primary" }
const _hoisted_26 = { class: "date" }
const _hoisted_27 = { class: "tempInfo flex" }
const _hoisted_28 = { class: "primary" }
const _hoisted_29 = { class: "hourlyWeather" }
const _hoisted_30 = { class: "listedDays" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1)
const _hoisted_32 = { class: "singleDay flex" }
const _hoisted_33 = { class: "time" }
const _hoisted_34 = { class: "temp" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsWidget = _resolveComponent("AlertsWidget")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_WeatherChart = _resolveComponent("WeatherChart")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("weather.title")), 1),
      _withDirectives((_openBlock(), _createElementBlock("button", {
        class: _normalizeClass(["flex gap-3 text-white border-none py-2 px-3 cursor-pointer border-round-3xl shadow-2 justify-content-between white-space-nowrap align-items-center", _ctx.user ? 'bg-primary' : 'bg-gray-400']),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleAlertsNavigation && _ctx.handleAlertsNavigation(...args)))
      }, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.alertsText), 1)
      ], 2)), [
        [
          _directive_tooltip,
          !_ctx.user ? _ctx.$t('weather.alerts.login') : null,
          void 0,
          { bottom: true }
        ]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("city.name")), 1),
      (_ctx.currently === null)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t("global.no_data")), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("canvas", _hoisted_10, null, 512),
          (_ctx.currently !== null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                _createTextVNode(_toDisplayString(_ctx.currently.temperature), 1),
                _hoisted_12
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.currently !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.currently.timeString), 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_14,
                  _createTextVNode(_toDisplayString(_ctx.currently.humidity) + "% ", 1)
                ]),
                _createElementVNode("li", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.currently.pressure) + " hPa", 1)
                ]),
                _createElementVNode("li", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("div", null, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.currently.windSpeed) + " km/h", 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.currently.windDirection), 1)
                    ])
                  ]),
                  _createElementVNode("img", {
                    style: _normalizeStyle({
                  transform: 'rotate(' + _ctx.currently.windBearing + 'deg)',
                }),
                    src: _imports_0,
                    alt: _ctx.$t('accessibility.weather.wind')
                  }, null, 12, _hoisted_21)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_AlertsWidget)
    ]),
    _createVNode(_component_Accordion, {
      activeIndex: 0,
      class: "dailyWeather",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleAccordionChange()))
    }, {
      default: _withCtx(() => [
        (_ctx.daily.data.length === 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.$t("alerts.no_daily_weather")), 1))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daily.data, (weather) => {
          return (_openBlock(), _createBlock(_component_AccordionTab, { key: weather }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$moment.unix(weather.time).format("dddd")), 1),
                  _createElementVNode("span", _hoisted_26, _toDisplayString(weather.timeString), 1)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["weatherIcon", weather.icon])
                  }, null, 2),
                  _createElementVNode("span", _hoisted_28, _toDisplayString(weather.temperatureHigh) + "°C", 1),
                  _createElementVNode("span", null, _toDisplayString(weather.temperatureLow) + "°C", 1)
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_swiper, {
                    breakpoints: _ctx.breakpoints,
                    modules: _ctx.modules,
                    pagination: { el: 'swiper-pagination', clickable: true }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_31,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weather.hourly, (hourlyData) => {
                        return (_openBlock(), _createBlock(_component_swiper_slide, { key: hourlyData }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("span", _hoisted_33, _toDisplayString(hourlyData.timeString), 1),
                              _createElementVNode("span", {
                                class: _normalizeClass(["weatherIcon", hourlyData.icon])
                              }, null, 2),
                              _createElementVNode("span", _hoisted_34, _toDisplayString(hourlyData.temperature) + "°C", 1)
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["breakpoints", "modules"])
                ]),
                _createVNode(_component_WeatherChart, {
                  percentage: 
              _ctx.currentTimeInPercents(weather.sunriseTime, weather.sunsetTime)
            ,
                  leftText: _ctx.$moment.unix(weather.sunriseTime).format('HH:mm'),
                  rightText: _ctx.$moment.unix(weather.sunsetTime).format('HH:mm')
                }, null, 8, ["percentage", "leftText", "rightText"])
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}